// src/App.jsx
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/home';
import Login from './components/login';
import AdminDashboard from './components/admindashboard';
import './App.css';
import Footer from './components/footer';
import ProductDetail from './components/productdetail'; // Import the ProductDetail componentD
import Contact from './components/contact';
import ProtectedRoute from './components/protectedroute';

function App() {
  return (
    <Router>
      <div className="app-container">    
        <main>
          <Routes>
            <Route path="/" element={<Home />} />           
            <Route path="/admin" element={<Login />} /> 
            <Route path="/admin/dashboard" element={ <ProtectedRoute> <AdminDashboard /> </ProtectedRoute> } />
            <Route path="/product/:id" element={<ProductDetail />} /> 
            <Route path="/contact" element={<Contact />} /> 
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
